import { Skeleton } from 'primereact/skeleton';
import React from 'react';

const LoadingSkeleton: React.FC<{}> = () => {
  return (
    <div>
      <Skeleton height="48px" className="mt-2" />
      <Skeleton height="48px" className="mt-2" />
      <Skeleton height="48px" className="mt-2" />
    </div>
  );
};

export default LoadingSkeleton;
